import * as React from "react";
import classnames from "classnames";
import { Icon } from "@grandvisionhq/icons";
import { getConcatClickTrackingAttributes } from "@grandvisionhq/svc-tealium/utils";
/* empty css          */
const Item = ({
  childMenuItems = [],
  label,
  link,
  onItemClick,
  parameters,
  tabIndex,
  linkRef
}) => {
  const hasChildMenuItems = childMenuItems && childMenuItems.length > 0;
  const hasClickHandler = onItemClick && hasChildMenuItems;
  const tealiumAttributes = getConcatClickTrackingAttributes(label, {
    "data-element-id": "MainNav"
  });
  const handleClick = React.useCallback(
    (event) => {
      if (hasClickHandler) {
        event.preventDefault();
        onItemClick && onItemClick(label);
      }
    },
    [hasClickHandler, label]
  );
  const menuKey = parameters && parameters.menuKey || "";
  const classes = classnames("site-nav-mobile__item", {
    [`site-nav-mobile__item--${menuKey}`]: menuKey,
    "site-nav-mobile_is_active": link && link.active
  });
  return /* @__PURE__ */ React.createElement("li", { className: classes }, /* @__PURE__ */ React.createElement(
    "a",
    {
      className: "site-nav-mobile__link",
      href: link?.href,
      target: link?.openInNewWindow ? "_blank" : "_self",
      onClick: handleClick,
      rel: "noreferrer",
      tabIndex,
      "aria-haspopup": !!hasChildMenuItems,
      ref: linkRef,
      ...tealiumAttributes
    },
    label
  ), hasChildMenuItems && /* @__PURE__ */ React.createElement(Icon, { name: "chevron-right" }));
};
export {
  Item as default
};
//# sourceMappingURL=Item.js.map
